import type { DealData, HubspotPlan } from '@types';
import { filteredSalesDeals } from '@shared/utils/hubspotDeals';

export const handleController = (plan: HubspotPlan | undefined) => {
  const deals = plan?.deals as unknown as DealData[];
  if (!deals) return '';

  const salesDeals = filteredSalesDeals(deals, true);

  if (!salesDeals || salesDeals.length === 0) return '';

  const closedWonDeals = salesDeals.filter(
    (deal) => deal.status === 'closedwon'
  );

  if (!closedWonDeals || closedWonDeals.length === 0) return '';

  const mostRecentClosedWonDeal = closedWonDeals.reduce((prev, curr) =>
    new Date(curr.closed_date).getTime() > new Date(prev.closed_date).getTime()
      ? curr
      : prev
  );
  return mostRecentClosedWonDeal.controller;
};

export const handleFinancialDeliveryDateDeal = (
  plan: HubspotPlan | undefined
) => {
  const deals = plan?.deals as unknown as DealData[];
  if (!deals) return '';

  const salesDeals = filteredSalesDeals(deals, true);

  if (!salesDeals || salesDeals.length === 0) return '';

  const closedWonDeals = salesDeals.filter(
    (deal) => deal.status === 'closedwon'
  );

  if (!closedWonDeals || closedWonDeals.length === 0) return '';

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { financial_delivery_date } = closedWonDeals.reduce((prev, curr) =>
    new Date(curr.closed_date).getTime() > new Date(prev.closed_date).getTime()
      ? curr
      : prev
  );

  return financial_delivery_date ?? '-';
};
